<template>
    <div class="notification is-link is-light" :style="styles" @click="$emit('vote')">
        <button class="delete" @click="$emit('close-notification')"></button>
        <p class="has-text-centered">
            <span class="icon"><fa icon="flag-checkered" /></span><span class="mu-font">VOTA</span><br>
            <small>¡Por nuestro MU!</small>
        </p>
    </div>
</template>

<script>
export default {
 name:'NormalNotification',
 computed: {
     styles() {
         return {
             'position':'absolute',
             'z-index': '20',
             'top': '70px',
             'right':'-2px',
             'cursor':'pointer'
         }
     }
 }
}
</script>

<style>

</style>